import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { toast, Toaster } from "sonner";
import { api, setToken } from "../lib/api";
import { useI18n } from "../lib/i18n";
import useTitle from "../lib/useTitle";
import { TYPE_META } from "../lib/constants";

export default function AdminLogin() {
  const { t } = useI18n();
  useTitle(t.admin.login);
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setToken(r.data.access_token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-sand-100 px-6" data-testid="admin-login-page">
      <Toaster position="top-center" richColors />
      <div className="w-full max-w-md bg-white rounded-3xl border border-sand-300/70 p-10 shadow-sm">
        <div className="flex items-center gap-3 mb-8">
          <img src={TYPE_META.hostel.logo} alt="" className="h-10 w-10" />
          <div>
            <div className="font-serif text-xl">Wostel Djerba</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-wostel-ink/60">{t.admin.login}</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-wider text-wostel-ink/60 mb-2 block">{t.admin.email}</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-sand-50 border border-sand-300 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-wostel-cyan"
              data-testid="admin-login-email" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-wostel-ink/60 mb-2 block">{t.admin.password}</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-sand-50 border border-sand-300 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-wostel-cyan"
              data-testid="admin-login-password" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full btn-pill bg-wostel-ink text-sand-50 hover:bg-wostel-cyan disabled:opacity-50"
            data-testid="admin-login-submit">
            <Lock size={14}/> {loading ? "..." : t.admin.signin} <ArrowRight size={14}/>
          </button>
        </form>
      </div>
    </main>
  );
}
